import CandidateInfo from './CandidateInfo.container';

export default CandidateInfo;
